// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"gf","categoryName":"hf","categoryImage":"if","categoryContent":"jf","bottomAligned":"kf"};